
import axios from 'axios';
const { REACT_APP_API_ENDPOINT } = process.env;

// GET /api/affissioni/offices_all
export async function fetchUffici() {
    const res = await axios.get(`${REACT_APP_API_ENDPOINT}/api/affissioni/offices_all`);
    return res.data;
}

// GET /api/affissioni/offices_filter
export async function fetchUfficiFilter(filter) {
    const res = await axios.get(`${REACT_APP_API_ENDPOINT}/api/affissioni/offices_filter`, { params: filter });
    return res.data;
}

// GET /api/affissioni/getone
export async function fetchUfficio(_id) {
    const res = await axios.get(`${REACT_APP_API_ENDPOINT}/api/affissioni/getone`, { params: { _id } });
    return res.data;
}

// POST /api/affissioni/create
export async function addUfficio(officeData) {
    const res = await axios.post(`${REACT_APP_API_ENDPOINT}/api/affissioni/create`, officeData);
    return res.data;
}

// POST /api/affissioni/update
export async function updateUfficio(officeData) {
    const res = await axios.post(`${REACT_APP_API_ENDPOINT}/api/affissioni/update`, officeData);
    return res.data;
}

// DELETE /api/affissioni/delete
export async function deleteUfficio(_id) {
    const res = await axios.delete(`${REACT_APP_API_ENDPOINT}/api/affissioni/delete`, { params: { _id } });
    return res.data;
}



